export const EmojiSadDim = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
  >
    <path
      stroke="url(#paint0_linear_5328_192124)"
      stroke-linecap="round"
      stroke-width="3.47"
      d="M3.483 10.927c-1.518-6.34 9.345-7.078 10.496-2.27 1.068 4.46-4.777 7.029-5.607 9.719-.83 2.69 0 2.983 0 2.983m0 5.743.085.358"
      opacity=".6"
    />
    <g filter="url(#filter0_f_5328_192124)">
      <ellipse cx="31.999" cy="61.074" fill="#F6F7F8" rx="23.515" ry="1.011" />
    </g>
    <mask
      id="mask0_5328_192124"
      width="42"
      height="42"
      x="11"
      y="9"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <circle cx="31.957" cy="29.924" r="20.924" fill="#fff" />
    </mask>
    <g mask="url(#mask0_5328_192124)">
      <circle cx="31.957" cy="29.924" r="20.924" fill="#85C0FC" />
      <circle
        cx="31.957"
        cy="29.924"
        r="20.924"
        fill="url(#paint1_radial_5328_192124)"
      />
      <circle
        cx="31.957"
        cy="29.924"
        r="20.924"
        fill="url(#paint2_linear_5328_192124)"
      />
      <g filter="url(#filter1_f_5328_192124)" opacity=".5">
        <path
          fill="url(#paint3_linear_5328_192124)"
          d="M43.67 45.32c5.77-4.442 7.015-8.864 7.891-15.05-1.855 7.309-5.172 10.678-9.935 14.099-5.491 3.943-10.253 4.5-18.31 3.733 7.062 1.826 14.274 1.897 20.354-2.782Z"
        />
      </g>
    </g>
    <g filter="url(#filter2_d_5328_192124)">
      <ellipse
        cx="41.977"
        cy="23.436"
        fill="url(#paint4_radial_5328_192124)"
        rx="7.804"
        ry="8.266"
        transform="rotate(20 41.977 23.436)"
      />
    </g>
    <ellipse
      cx="46.517"
      cy="27.888"
      fill="#fff"
      rx=".754"
      ry="1.914"
      transform="rotate(44.325 46.517 27.888)"
    />
    <ellipse
      cx="42.982"
      cy="30.117"
      fill="#fff"
      rx=".406"
      ry="1.031"
      transform="rotate(77.674 42.982 30.117)"
    />
    <g filter="url(#filter3_d_5328_192124)">
      <ellipse
        cx="21.659"
        cy="23.442"
        fill="url(#paint5_radial_5328_192124)"
        rx="7.804"
        ry="8.266"
        transform="rotate(-20 21.659 23.442)"
      />
    </g>
    <ellipse
      cx="28.002"
      cy="23.942"
      fill="#fff"
      rx=".754"
      ry="1.914"
      transform="rotate(4.326 28.002 23.942)"
    />
    <ellipse
      cx="26.721"
      cy="27.916"
      fill="#fff"
      rx=".406"
      ry="1.031"
      transform="rotate(37.674 26.72 27.916)"
    />
    <circle cx="42.498" cy="20" r="2" fill="#0052B3" opacity=".6" />
    <circle cx="21.498" cy="26" r="2" fill="#0052B3" opacity=".6" />
    <path
      stroke="#0052B3"
      stroke-linecap="round"
      stroke-width="2.242"
      d="M25.5 42.547s1.186-3.048 6.434-3.048 6.434 3.048 6.434 3.048"
      opacity=".6"
    />
    <path
      stroke="url(#paint6_linear_5328_192124)"
      stroke-linecap="round"
      stroke-width="3.47"
      d="M50.144 38.334c1.314-4.203 5.49-1.16 4.493 2.027-.924 2.957-3.482 1.806-4.788 3.243-1.306 1.438-.885 2.831-.885 2.831m-.322 3.358-.075.238"
      opacity=".6"
    />
    <path
      stroke="url(#paint7_linear_5328_192124)"
      stroke-linecap="round"
      stroke-width="3.47"
      d="M50.149 7.115c-.562-3.364 4.066-2.835 4.492-.283.395 2.367-2.161 2.53-2.674 4-.513 1.469.379 2.265.379 2.265m1.047 2.418.032.19"
      opacity=".6"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5328_192124"
        x1=".374"
        x2="15.385"
        y1="29.642"
        y2="25.705"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#003B80" />
        <stop offset=".438" stop-color="#E5F1FF" />
        <stop offset=".958" stop-color="#003B80" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5328_192124"
        x1="22.008"
        x2="34.941"
        y1="11.078"
        y2="29.377"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".075" stop-color="#B3D6FF" />
        <stop offset=".353" stop-color="#E6F1FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5328_192124"
        x1="43.397"
        x2="36.138"
        y1="45.394"
        y2="38.237"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A83FF" />
        <stop offset="1" stop-color="#E6F1FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_5328_192124"
        x1="43.414"
        x2="50.196"
        y1="48.588"
        y2="50.599"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#003B80" />
        <stop offset=".438" stop-color="#E5F1FF" />
        <stop offset=".958" stop-color="#003B80" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_5328_192124"
        x1="48.618"
        x2="54.982"
        y1="16.634"
        y2="15.457"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#003B80" />
        <stop offset=".438" stop-color="#E5F1FF" />
        <stop offset=".958" stop-color="#003B80" />
      </linearGradient>
      <filter
        id="filter0_f_5328_192124"
        width="50.463"
        height="5.457"
        x="6.768"
        y="58.346"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192124"
          stdDeviation=".858"
        />
      </filter>
      <filter
        id="filter1_f_5328_192124"
        width="32.536"
        height="23.276"
        x="21.171"
        y="28.128"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192124"
          stdDeviation="1.073"
        />
      </filter>
      <filter
        id="filter2_d_5328_192124"
        width="29.244"
        height="29.949"
        x="28.858"
        y="10.712"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.502" dy="2.253" />
        <feGaussianBlur stdDeviation="3.38" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.784 0 0 0 0 0.8 0 0 0 0 0.816 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5328_192124"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5328_192124"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_5328_192124"
        width="29.244"
        height="29.949"
        x="8.539"
        y="10.72"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.502" dy="2.253" />
        <feGaussianBlur stdDeviation="3.38" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.784 0 0 0 0 0.8 0 0 0 0 0.816 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5328_192124"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5328_192124"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint1_radial_5328_192124"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(22.56203 21.52868 -20.13218 21.0985 24.889 24.16)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3D6FF" />
        <stop offset=".418" stop-color="#80BAFF" />
        <stop offset=".736" stop-color="#1A83FF" />
        <stop offset="1" stop-color="#006AE6" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_5328_192124"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -3.96 57.146) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#E3E6E8" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_5328_192124"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -14.125 34.02) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#E3E6E8" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
    </defs>
  </svg>
);
